<template>
  <div>
    <el-form-item label="声明入口图片:"
                  prop="notInSaleAreaWarningImage">
      <upload-with-crop v-model="ruleForm.scanH5StatementEntryImage"
                        style="--custom-width: 200px; --custom-height: 70px;"
                        :cropperCheck="false"
                        :isCompress="false"
                        :limit="1" />
    </el-form-item>
    <el-form-item label="内容长图:"
                  prop="scanH5StatementImages">
      <desc-images-new v-model="ruleForm.scanH5StatementImages" />
    </el-form-item>
  </div>
</template>

<script>
import UploadWithCrop from '@/components/upload-with-crop/upload-with-crop.vue'
import DescImagesNew from '@/components/upload-with-crop/desc-images-new.vue'
export default {
  name: 'declaration-config-form',
  components: { UploadWithCrop, DescImagesNew },
  props: {
    value: { type: Object, default: () => ({}) }
  },
  computed: {
    ruleForm: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  }
}
</script>
